// 🫀 B367-FU2 (AI_156) — SEGMENTOS HEPÁTICOS CITADOS NA ANÁLISE DE IMAGEM
// ─────────────────────────────────────────────────────────────
// A conferência automática da Situação Especial (CHC) dizia ao médico que os
// dois critérios ANATÔMICOS ("ressecção de > 2 segmentos", "tumores em
// segmentos distintos") dependiam da leitura dele porque "o sistema não tem
// como vê-los". Isso era FALSO: o exame de imagem é analisado pela IA e tanto
// a análise como o laudo recebem esse texto (Leonardo, 29/10/2026).
//
// O que o sistema de verdade NÃO faz é DECIDIR o critério — "dois nódulos em
// segmentos diferentes" pode ser uma lesão única que cruza a fronteira, e a
// extensão da ressecção é julgamento cirúrgico. Então aqui não se decide nada:
// lê-se a análise já feita e mostram-se os SEGMENTOS CITADOS, para o médico
// julgar com o dado na frente em vez de ser informado de uma cegueira que o
// sistema não tem.
//
// Conservador por desenho: só conta segmento escrito junto da palavra
// "segmento(s)" — "V" solto é numeral romano ambíguo em texto clínico.
// ─────────────────────────────────────────────────────────────

const ROMANO_PARA_NUMERO: Record<string, number> = {
  i: 1, ii: 2, iii: 3, iv: 4, v: 5, vi: 6, vii: 7, viii: 8,
};
const NUMERO_PARA_ROMANO = ["", "I", "II", "III", "IV", "V", "VI", "VII", "VIII"];

/** Trecho que segue a palavra "segmento(s)" — onde os números vivem. */
const TRECHO_SEGMENTO = /segmentos?\s+([^.;:\n]{0,45})/gi;
// Romanos mais longos primeiro; \b evita casar o "v" de "vi".
const TOKEN = /\b(viii|vii|vi|iv|iii|ii|i|v)\b|\b([1-8])\b/gi;

/**
 * Segmentos hepáticos citados no texto, em romano e ordenados (ex.: ["V","VI"]).
 * Aceita "segmento V", "segmentos V e VI", "segmentos V/VI", "segmento 5".
 */
export function segmentosCitados(texto?: string | null): string[] {
  const t = String(texto || "");
  if (!t) return [];
  const achados: number[] = [];
  // Regex com /g é stateful: zerar lastIndex antes de cada varredura.
  TRECHO_SEGMENTO.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = TRECHO_SEGMENTO.exec(t)) !== null) {
    const trecho = m[1] || "";
    TOKEN.lastIndex = 0;
    let tk: RegExpExecArray | null;
    while ((tk = TOKEN.exec(trecho)) !== null) {
      const romano = tk[1];
      const arabe = tk[2];
      const n = romano ? ROMANO_PARA_NUMERO[romano.toLowerCase()] : Number(arabe);
      if (n >= 1 && n <= 8 && achados.indexOf(n) === -1) achados.push(n);
    }
  }
  return achados.sort((a, b) => a - b).map((n) => NUMERO_PARA_ROMANO[n]);
}

/** Lista para o olho humano: "V", "V e VI", "V, VI e VIII". */
export function listarSegmentos(segmentos: string[]): string {
  if (segmentos.length === 0) return "";
  if (segmentos.length === 1) return segmentos[0];
  return `${segmentos.slice(0, -1).join(", ")} e ${segmentos[segmentos.length - 1]}`;
}
